/*
 * Copyright (c) 2023. Bolmate B.V.
 */
import './style/cancelDiscountOffer.scss';

import {Loader, WithBackground} from '@dvrd/dvr-controls';
import React, {MouseEventHandler} from 'react';
import {BolmateButton} from "../../../controls";

interface Props {
    onClose: MouseEventHandler;
    onProceed: MouseEventHandler;
    onApplyDiscount: MouseEventHandler;
    active: boolean;
    loading: boolean;
}

export default function CancelDiscountOffer(props: Props) {
    const {onApplyDiscount, onClose, onProceed, active, loading} = props;

    function renderBody() {
        return (
            <div className='body-container'>
                <Loader active={loading}/>
                <p className='message'>Jammer dat je wilt vertrekken.<br/>
                    Bolmate bewijst zich over de tijd.<br/><br/>
                    {/*Weet je zeker dat je nu weg wilt gaan?<br/>*/}
                    Kijk het nog even aan met 50% korting voor 6 maanden.<br/>
                    Daarna kunnen we samen verder kijken.
                </p>
                <BolmateButton onClick={onApplyDiscount} label='50% korting voor 6 maanden toepassen'
                               className='btn-discount'/>
            </div>
        )
    }

    return (
        <WithBackground active={active} onClose={onClose} preventBackgroundClick escapeDisabled>
            <div className='cancel-discount-offer default-popup'>
                <div className='header-container'>
                    <label className='header-title'>50% korting voor 6 maanden</label>
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BolmateButton onClick={onClose} label='Annuleren' disabled={loading} secondary/>
                    <BolmateButton onClick={onProceed} label='Nee, ik wil toch opzeggen' disabled={loading} secondary/>
                </div>
            </div>
        </WithBackground>
    )
}